"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var utils_1 = __importDefault(require("@nexys/utils"));

var Code = function Code(props) {
  var data = props.data,
      name = props.name,
      onChange = props.onChange,
      id = props.id;
  var strName = name.toString();
  var v = utils_1.default.ds.get(strName, data);
  var value = v !== null ? v : '';

  var handleChange = function handleChange(x) {
    return onChange({
      name: String(name),
      value: x.target.value
    });
  };

  return react_1.default.createElement("textarea", {
    id: id ? id : strName,
    name: strName,
    value: value,
    onChange: handleChange
  });
};

exports.default = Code;